import script from "./TeamWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamWidget.vue?vue&type=script&setup=true&lang=js"

import "./TeamWidget.vue?vue&type=style&index=0&id=e4a62ec2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4a62ec2"]])

export default __exports__